import clsx from 'clsx';
import { useTranslate } from 'core/hooks/useTranslate';
import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'ui';
import useIframeViewer from './useIframeViewer';

const IframeViewer = ({ url, size, aspectRatio, title, contentGuid, courseGuid, jobGuid }) => {
  const { t } = useTranslate();
  const { embedUrl, origin, openLink } = useIframeViewer({ url, contentGuid, courseGuid, jobGuid });

  return (
    <div className={clsx('iframe-viewer', `iframe-viewer--size-${size}-${aspectRatio}`)}>
      {embedUrl && origin && <iframe src={embedUrl}></iframe>}
      <div className="iframe-viewer__footer">
        <p className="iframe-viewer__footer-origin">{origin || t('ui:URL not available')}</p>
        {title && (
          <div className="iframe-viewer__footer-link">
            <p className="iframe-viewer__footer-title">{title}</p>
            <div className="iframe-viewer__footer-icon" onClick={openLink}>
              <Icon name="external-link" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

IframeViewer.defaultProps = {
  url: 'https://www.example.com',
  size: 'md',
  aspectRatio: 'widescreen',
};

IframeViewer.propTypes = {
  url: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  aspectRatio: PropTypes.oneOf(['widescreen', 'standard', 'square']),
  title: PropTypes.string,
  contentGuid: PropTypes.string,
  courseGuid: PropTypes.string,
  jobGuid: PropTypes.string,
};

export default IframeViewer;
